"use client";

import { useEffect, useState } from "react";

const NARROW_VIEWPORT_QUERY = "(max-width: 47.99rem)";

/**
 * True below the tablet breakpoint, where the gallery drops masonry for a
 * linear full-width list. Guards against environments without matchMedia
 * (jsdom), where it stays false.
 */
export function useIsNarrowViewport(): boolean {
  const [isNarrow, setIsNarrow] = useState(false);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(NARROW_VIEWPORT_QUERY);
    const update = () => setIsNarrow(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);
  return isNarrow;
}
